// Gallery photos are emitted as fingerprinted /assets files so the host can
// cache them for a year. Unhashed /gallery/* files were served with no
// Cache-Control, which Lighthouse flags on repeat mobile visits.
const modules = import.meta.glob("../assets/gallery/*.{jpg,jpeg,png,webp}", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

const byFilename = new Map<string, string>();

for (const [path, url] of Object.entries(modules)) {
  const filename = path.split("/").pop();
  if (filename) byFilename.set(filename, url);
}

export function gallerySrc(filename: string): string {
  return byFilename.get(filename) ?? `/gallery/${filename}`;
}
